import axios from "axios";
import { irenderRentalConfig, EXECUTE_RESULT } from "@/constant/config";
// export function getMachineList() {
//     return axios.request({
//         url: irenderRentalConfig.getMachineList,
//         method: "get",
//         withCredentials: true,
//     });
// }

export default {

    // Rental request
    rentalRequestCreate: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.rentalRequestCreateUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get machine list 
    getMachineList: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                url: `${irenderRentalConfig.machineListViewUrl}?${request}`,
                method: "GET",
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get service pack list
    getServicePackList() {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: irenderRentalConfig.getServicePackListUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get service package
    getServicePackage(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: `${irenderRentalConfig.getServicePackageUrl}/${request}`,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get category list
    getCategoryList() {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: irenderRentalConfig.getCategoryListUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get master list
    getMasterList(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: irenderRentalConfig.getMasterListUrl.format(request.servicePack, request.categoryId, request.operatingSystem),
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get software list
    getSoftwareList(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: irenderRentalConfig.getSoftwareListUrl.format(request),
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Boot machine
    bootMachine: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.bootMachineUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Clone image
    cloneImage: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.cloneImageUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Shutdown machine
    shutdownMachine: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.shutdownMachineUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Reset machine
    resetMachine: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.resetMachineUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Cancel machine
    cancelMachine: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.cancelMachineUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Remove machine
    removeMachine: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.removeMachineUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Rename machine
    renameMachine: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.renameMachineUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Create machine
    createMachine: function (createImageRequest) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.createMachineUrl,
                data: createImageRequest,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTem = res.toJSON();
                        if (resTem.name === 'Error') {
                            reject(resTem);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Create image fixed rental
    createImageFixedRental: function (createImageRequest) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.createImageFixedRentalUrl,
                data: createImageRequest,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTem = res.toJSON();
                        if (resTem.name === 'Error') {
                            reject(resTem);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Download remote desktop
    downloadRemoteDesktop: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.downloadMachineUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTem = res.toJSON();
                        if (resTem.name === 'Error') {
                            reject(resTem);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Request image 
    requestImage(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.requestImageUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Pre-boot machine
    preBootMachine(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.preBootMachineUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get availability service
    getAvailabilityService(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: irenderRentalConfig.getAvailabilityServiceUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Change service package
    changeServicePackage(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.changeServicePackageUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Rental request
    rentalRequest: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.rentalRequestFixedRentalUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Request notification machine
    countNumberMachine: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: irenderRentalConfig.countNumberMachineUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Pre create image
    preCreateImage: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.preCreateImageUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get package change list
    getPackageChangeList: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: `${irenderRentalConfig.getPackageChangeListUrl}/${request}`,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // MACHINE LIST ___ VIEW
    machineListView: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: `${irenderRentalConfig.machineListViewUrl}/${request}`,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // FIXED RENTAL ___ GET PRICE
    getPrice: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: `${irenderRentalConfig.getPriceUrl}/${request}`,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Fixed rental create
    fixedRentalCreate: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.fixedRentalCreateUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // RENTAL REQUEST ___ VIEW
    rentalRequestView: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: `${irenderRentalConfig.rentalRequestViewUrl}?${request}`,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // FIXED RENTAL VIEW
    fixedRentalView: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: `${irenderRentalConfig.fixedRentalViewUrl}/${request}`,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Renewal
    renewal: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.renewalUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Fixed rental deactivate
    deactivateFixedRental: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.deactivateFixedRentalUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Fixed rental settings
    fixedRentalSettings: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: irenderRentalConfig.fixedRentalSettingsUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },




    //Server report view
    serverReportView() {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: irenderRentalConfig.serverReportViewUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    serverReportViewDelayed(){
        axios({
            method: "GET",
            url: irenderRentalConfig.serverReportDelayedViewUrl,
            withCredentials: true,
        })
            .then(res => {
                try {
                    let resTemp = res.toJSON();
                    if (resTemp.name === 'Error') {
                        reject(resTemp);
                    }
                } catch {
                    let response = res.data;
                    if (response.result === EXECUTE_RESULT.SUCCESS) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                }
            })
            .catch(error => {
                reject(error);
            });
    }
}